import React from 'react';
import { graphql } from 'gatsby';
import { PopUp } from '@agria/theme/src/components/popup/PopUp';
import { Video } from '@agria/theme/src/components/video/Video';
import { Play } from '@agria/theme/src/components/icon';
import { ModalProvider } from '../../../../context/modalContext';

export const ButtonBarVideo = ({ data, ...rest }) => (
  <ModalProvider>
    <PopUp actionLabel={data.label} iconLeft={<Play />}>
      <Video url={data.videoId} />
    </PopUp>
  </ModalProvider>
);

export const ButtonBarVideoQuery = graphql`
  fragment ButtonBarVideo on UMBRACO_ButtonBarVideoComponentType {
    label
    videoId
  }
`;
